// Updated GSAP ScrollTrigger script for all sections
// Make sure GSAP and ScrollTrigger are loaded before this script

// Wait until DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  // === SECTION 1: Blog Sections Animation ===
  const blogSections = document.querySelectorAll('.blog__section');
  if (blogSections.length) {
    blogSections.forEach((section) => {
      const header = section.querySelector('.blog__section__header');
      const title = header?.querySelector('h2');
      const link = header?.querySelector('.animate-btn');
      const description = header?.querySelector('.s-featured-articles__description');
      const articlesWrapper = section.querySelector('.s-featured-articles__list');
      const articleItems = section.querySelectorAll('.s-featured-articles__item');

      // Headline fade from top
      if (title && link) {
        gsap.from([title, link], {
          y: 20,
          opacity: 0,
          duration: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: header,
            start: 'top 80%',
            end: 'bottom 0%',
            toggleActions: 'play reverse play reverse',
          },
        });
      }

      if (link) {
        link.addEventListener('mouseenter', () => {
          gsap.to(link, {
            scale: 1.05,
            duration: 0.2,
            ease: 'power1.out',
          });
        });

        link.addEventListener('mouseleave', () => {
          gsap.to(link, {
            scale: 1,
            duration: 0.2,
            ease: 'power1.out',
          });
        });
      }

      // Articles fade in stagger
      if (articleItems.length > 0 && articlesWrapper) {
        gsap.fromTo(articleItems,
          { y: 20, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.6,
            ease: "power2.out",
            stagger: 0.15,
            scrollTrigger: {
              trigger: articlesWrapper,
              start: "top 80%",
              toggleActions: "play reverse play reverse"
            }
          }
        );
      }

      // Tags scale-in from left (each individually)
      articleItems.forEach((item) => {
        const tags = item.querySelectorAll('.c-article-card__tag');
        const title = item.querySelector('.c-article-card__title');
        const info = item.querySelector('.c-article-card__info');
  
        tags.forEach((tag) => {
          gsap.fromTo(tag,
            { x: -10, scale: 0.95, opacity: 0 },
            {
              x: 0,
              scale: 1,
              opacity: 1,
              duration: 0.4,
              ease: "power2.out",
              scrollTrigger: {
                trigger: tag,
                start: "top 80%",
                toggleActions: "play reverse play reverse"
              }
            }
          );
        });

        // Title fade from top
        if (title) {
          gsap.fromTo(title,
            { y: -20, opacity: 0 },
            {
              y: 0,
              opacity: 1,
              duration: 0.5,
              ease: "power2.out",
              scrollTrigger: {
                trigger: title,
                start: "top 80%",
                toggleActions: "play reverse play reverse"
              }
            }
          );
        }
  
        // Info fade from bottom
        if (info) {
          gsap.fromTo(info,
            { y: 20, opacity: 0 },
            {
              y: 0,
              opacity: 1,
              duration: 0.5,
              delay: 0.1,
              ease: "power2.out",
              scrollTrigger: {
                trigger: info,
                start: "top 80%",
                toggleActions: "play reverse play reverse"
              }
            }
          );
        }
      });
    });
  }

  // === SECTION 2: Subscribe Section Animation ===
  const subscribeSection = document.querySelector('.subscribe');
  if (subscribeSection) {
    const wrapper = subscribeSection.querySelector('.subscribe__wrapper');
    const title = wrapper?.querySelector('.subscribe__title');
    const text = wrapper?.querySelector('.subscribe__text');
    const form = wrapper?.querySelector('.subscribe__form');
    const button = wrapper?.querySelector('.subscribe__form-submit');

    if (title && text && form) {
      gsap.from([title, text, form], {
        y: 20,
        opacity: 0,
        stagger: 0.2,
        duration: 0.6,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: wrapper,
          start: 'top 80%',
          end: 'bottom 0%',
          toggleActions: 'play reverse play reverse',
        },
      });
    }

    if (button) {
      gsap.fromTo(
        button,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.4,
          duration: 0.5,
          ease: 'back.out(1.7)',
          scrollTrigger: {
            trigger: button,
            start: 'top 80%',
            toggleActions: 'play reverse play reverse',
          },
        }
      );

      button.addEventListener('mouseenter', () => {
        gsap.to(button, { scale: 1.05, duration: 0.2, ease: 'power1.out' });
      });

      button.addEventListener('mouseleave', () => {
        gsap.to(button, { scale: 1, duration: 0.2, ease: 'power1.out' });
      });
    }
  }

  // === SECTION 3: Subscription Section Animation ===
  const subscriptionSection = document.querySelector('.s-subscription');
  if (subscriptionSection) {
    const title = subscriptionSection.querySelector('.s-subscription__title');
    const description = subscriptionSection.querySelector('.s-subscription__description');
    const form = subscriptionSection.querySelector('.s-subscription__form');
    const imageWrapper = subscriptionSection.querySelector('.s-subscription__image-wrapper');
    const subscribeButton = subscriptionSection.querySelector('.s-subscription__button');
  
    // Fade up & stagger for text + form (repeatable)
    gsap.from([title, description, form], {
      y: 20,
      opacity: 0,
      stagger: 0.2,
      duration: 0.6,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: subscriptionSection,
        start: 'top 80%',
        end: 'bottom 0%',
        toggleActions: 'play reverse play reverse',
      },
    });
  
    // Cat illustration animation (repeatable)
    if (imageWrapper) {
      gsap.fromTo(
        imageWrapper,
        { x: 40, opacity: 0, scale: 0.9 },
        {
          x: 0,
          opacity: 1,
          scale: 1,
          duration: 0.8,
          ease: 'elastic.out(1, 0.4)',
          scrollTrigger: {
            trigger: imageWrapper,
            start: 'top 80%',
            end: 'bottom 0%',
            toggleActions: 'play reverse play reverse',
          },
        }
      );
    }

    // Animate button pop-in (Subscribe)
    if (subscribeButton) {
      gsap.fromTo(
        subscribeButton,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.5,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: subscribeButton,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
  
      subscribeButton.addEventListener("mouseenter", () => {
        gsap.to(subscribeButton, { scale: 1.05, duration: 0.2, ease: "power1.out" });
      });
      subscribeButton.addEventListener("mouseleave", () => {
        gsap.to(subscribeButton, { scale: 1, duration: 0.2, ease: "power1.out" });
      });
    }
  }

  // === SECTION 4: Featured Articles Animation ===
  const featuredSections = document.querySelectorAll('s-featured-articles');
  
  if (featuredSections.length) {
    featuredSections.forEach((section) => {
      const header = section.querySelector('.s-featured-articles__top');
      const title = header?.querySelector('.s-featured-articles__title');
      const description = header?.querySelector('.s-featured-articles__description');
      const link = header?.querySelector('.s-featured-articles__link');
  
      const articlesWrapper = section.querySelector('.s-featured-articles__list');
      const articleItems = section.querySelectorAll('.s-featured-articles__item');
  
      // Headline and Link fade from top
      if (title && link) {
        gsap.from([title, link], {
          y: 20,
          opacity: 0,
          duration: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: header,
            start: 'top 80%',
            end: 'bottom 0%',
            toggleActions: 'play reverse play reverse',
          },
        });
      }
  
      // Link hover scale
      if (link) {
        link.addEventListener('mouseenter', () => {
          gsap.to(link, {
            scale: 1.05,
            duration: 0.2,
            ease: 'power1.out',
          });
        });
        link.addEventListener('mouseleave', () => {
          gsap.to(link, {
            scale: 1,
            duration: 0.2,
            ease: 'power1.out',
          });
        });
      }
  
      // Articles fade in stagger
      if (articleItems.length > 0 && articlesWrapper) {
        gsap.fromTo(articleItems,
          { y: 20, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.6,
            ease: "power2.out",
            stagger: 0.15,
            scrollTrigger: {
              trigger: articlesWrapper,
              start: "top 80%",
              toggleActions: "play reverse play reverse"
            }
          }
        );
      }
  
      // Animate each article card contents
      articleItems.forEach((item) => {
        const card = item.querySelector('.c-article-card');
  
        if (!card) return;
  
        const tags = card.querySelectorAll('.c-article-card__tag');
        const cardTitle = card.querySelector('.c-article-card__title');
        const info = card.querySelector('.c-article-card__info');
        const image = card.querySelector('.c-article-card__img');
  
        // Tags scale from left
        tags.forEach((tag) => {
          gsap.fromTo(tag,
            { x: -10, scale: 0.95, opacity: 0 },
            {
              x: 0,
              scale: 1,
              opacity: 1,
              duration: 0.4,
              ease: "power2.out",
              scrollTrigger: {
                trigger: tag,
                start: "top 80%",
                toggleActions: "play reverse play reverse"
              }
            }
          );
        });
  
        // Title fade from top
        if (cardTitle) {
          gsap.fromTo(cardTitle,
            { y: -20, opacity: 0 },
            {
              y: 0,
              opacity: 1,
              duration: 0.5,
              ease: "power2.out",
              scrollTrigger: {
                trigger: cardTitle,
                start: "top 80%",
                toggleActions: "play reverse play reverse"
              }
            }
          );
        }
  
        // Info fade from bottom
        if (info) {
          gsap.fromTo(info,
            { y: 20, opacity: 0 },
            {
              y: 0,
              opacity: 1,
              delay: 0.1,
              duration: 0.5,
              ease: "power2.out",
              scrollTrigger: {
                trigger: info,
                start: "top 80%",
                toggleActions: "play reverse play reverse"
              }
            }
          );
        }
  
        // Image zoom + fade
        if (image) {
          gsap.fromTo(image,
            { scale: 1.05, opacity: 0 },
            {
              scale: 1,
              opacity: 1,
              duration: 0.6,
              ease: "power2.out",
              scrollTrigger: {
                trigger: image,
                start: "top 80%",
                toggleActions: "play reverse play reverse"
              }
            }
          );
        }
      });
    });
  }

  // === SECTION 5: Article Details Animation ===
  const articleRoot = document.querySelector('.article--template');
  
  if (articleRoot) {
    const contentRoot = articleRoot.querySelector('article-content');
    if (!contentRoot) return;
  
    const animatedEls = contentRoot.querySelectorAll(
      'h1, h2, h3, h4, h5, h6, p, ul, ol, li, blockquote, img, footer, .colored__box, .colored__box_simple, .image_text_list li'
    );
  
    animatedEls.forEach((el, i) => {
      let fromProps = { opacity: 0, y: 20 };
      let toProps = {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 80%',
          toggleActions: 'play none none reverse'
        }
      };
  
      // Specific stagger for list items
      if (el.matches('li')) {
        toProps.delay = 0.05 * (i % 5);
      }
  
      // Different animation for images
      if (el.tagName.toLowerCase() === 'img') {
        fromProps = { opacity: 0, scale: 1.05 };
        toProps = {
          opacity: 1,
          scale: 1,
          duration: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 80%',
            toggleActions: 'play none none reverse'
          }
        };
      }
  
      gsap.fromTo(el, fromProps, toProps);
    });
  }

  // === SECTION 6: Feature Slider Animations ===
  const featureSlider = document.querySelector(".s-feature-slider");
  if (featureSlider) {
    const title = featureSlider.querySelector(".s-feature-slider__title");
    const slides = featureSlider.querySelectorAll(".s-feature-slider__slide");

    gsap.fromTo(
      featureSlider,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: featureSlider,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    if (title) {
      gsap.fromTo(title,
        { x: -30, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: featureSlider,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    slides.forEach((slide, index) => {
      gsap.fromTo(slide, { y: 40, opacity: 0 }, {
        y: 0,
        opacity: 1,
        duration: 0.6,
        delay: index * 0.1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: slide,
          start: "top 80%",
          toggleActions: "play reverse play reverse"
        }
      });
    });
  }

  // === SECTION 7: Catalog Download Animation ===
  const catalogSection = document.querySelector('.s-catalog-download');

  if (catalogSection) {
    const title = catalogSection.querySelector('.s-catalog-download__title');
    const text = catalogSection.querySelector('.s-catalog-download__text');
    const button = catalogSection.querySelector('.why-us-section__link');

    // Section fade-out
    gsap.fromTo(
      catalogSection,
      { opacity: 1, y: 0 },
      {
        opacity: 0,
        y: -60,
        ease: "power2.out",
        scrollTrigger: {
          trigger: catalogSection,
          start: "bottom 40%",
          end: "bottom top",
          scrub: true
        }
      }
    );

    // Title animation
    if (title) {
      gsap.fromTo(
        title,
        { y: -20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: title,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    // Text animation
    if (text) {
      gsap.fromTo(
        text,
        { y: 20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          delay: 0.15,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: text,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    // Button animation (same style as others)
    if (button) {
      gsap.fromTo(
        button,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.35,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: button,
            start: "top 85%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }

  // Always refresh ScrollTrigger to ensure layout is measured correctly
  ScrollTrigger.refresh();
});
